export default __webpack_public_path__ + "static/media/collectives-fcfafl.b246c800.svg";